<template>
  <div class="mb-5">
    <v-card class="mx-auto" max-width="1200" outlined>
      <v-container>
        <v-row v-if="postBasicEdit">
          <v-col class="text-center right-line" lg="4" md="4">
            <v-form ref="leftPostBasicForm">
              <LeftPostBasicEdit
                :edit-post-type="editablePostBasic.postType"
                :editing-eyecatchable-src="editingEyecatchableSrc"
                :eyecatchable="
                  editablePostBasic.eyecatchable
                    ? editablePostBasic.eyecatchable
                    : {}
                "
                :edit-product="
                  editablePostBasic.product ? editablePostBasic.product : {}
                "
                :edit-eyecatch-source-url="
                  editablePostBasic.eyecatchSourceUrl
                    ? editablePostBasic.eyecatchSourceUrl
                    : ''
                "
                @display-image-uploader-selecter="imageUploaderSelecter = true"
                @delete-eyecatch="deleteEyecatch"
                @input-eyecatch-source-url="
                  editablePostBasic.eyecatchSourceUrl = $event
                "
                @select-product="selectProduct"
                @change-post-type="$set(editablePostBasic, 'postType', $event)"
              ></LeftPostBasicEdit>
            </v-form>
          </v-col>

          <v-col lg="8" md="8">
            <v-form ref="rightPostBasicForm" @submit.prevent="onSubmit">
              <image-uploader-selecter
                :image-uploader-selecter="imageUploaderSelecter"
                :image-direct-url.sync="editablePostBasic.imageDirectUrl"
                @close-image-uploader-selecter="imageUploaderSelecter = false"
                @select-picture="updateImage"
                @upload-download-image="uploadDownloadImage"
                @upload-picture="uploadPicture"
              />
              <div class="mb-2">
                <v-text-field
                  v-model="editablePostBasic.title"
                  :counter="40"
                  autofocus
                  :rules="[
                    presenceValidation,
                    stringLengthValidation(editablePostBasic.title, 100),
                  ]"
                >
                  <template v-slot:label>
                    <InputLabel label-name="タイトル" :required="true" />
                  </template>
                </v-text-field>
              </div>
              <div class="mb-2">
                <v-text-field
                  v-model="editablePostBasic.metaTitle"
                  :counter="40"
                  autofocus
                  :rules="[
                    stringLengthValidation(editablePostBasic.metaTitle, 100),
                  ]"
                >
                  <template v-slot:label>
                    <InputLabel label-name="メタタイトル" />
                  </template>
                </v-text-field>
              </div>
              <div>
                <v-textarea
                  v-model="editablePostBasic.introduction"
                  class="body-2"
                  :counter="200"
                  :rules="[
                    stringLengthValidation(editablePostBasic.introduction, 200),
                  ]"
                >
                  <template v-slot:label>
                    <InputLabel label-name="導入文" />
                  </template>
                </v-textarea>
                <v-row>
                  <v-col class="pb-0">
                    <InputLabel
                      label-name="パーマリンク"
                      class="text-caption"
                      :required="true"
                    />
                  </v-col>
                  <v-col lg="12" class="d-flex">
                    <span class="pt-1 px-2"
                      >{{ site.originalDomainWithProtocol }}/</span
                    >
                    <v-text-field
                      v-model="editablePostBasic.slug"
                      class="pt-0 ma-0"
                      style="max-width: 150px"
                      :rules="[presenceValidation]"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col lg="12" class="d-flex flex-wrap">
                    <v-checkbox
                      style="width: 25%; white-space: nowrap"
                      v-model="editablePostBasic.isIndex"
                      label="インデックスする"
                    />
                    <v-checkbox
                      style="width: 25%; white-space: nowrap"
                      v-model="editablePostBasic.isPagination"
                      label="ページネーション"
                    />
                    <v-checkbox
                      style="width: 25%; white-space: nowrap"
                      v-model="editablePostBasic.isMoral"
                      label="道徳的な記事"
                    />
                    <v-checkbox
                      style="width: 25%; white-space: nowrap"
                      v-model="editablePostBasic.isPr"
                      label="PR"
                    />
                  </v-col>
                  <v-col lg="12" class="d-flex flex-wrap">
                    <v-checkbox
                        style="width: 50%; white-space: nowrap"
                        v-model="editablePostBasic.displayWidget"
                        label="広告（ウィジェット）を表示する"
                      />

                    <v-checkbox
                        style="width: 50%; white-space: nowrap"
                        v-model="editablePostBasic.isPremiumDisplay"
                        label="景品表示法文言を表示する"
                      />
                  </v-col>
                  <v-col lg="5">
                    <v-select
                      v-model="editablePostBasic.isTableOfContents"
                      label="目次表示"
                      :items="isTableOfContentsTypes"
                      item-text="name"
                      item-value="value"
                    />
                  </v-col>
                  <v-col lg="12" class="d-flex justify-end mt-3">
                    <v-btn
                      class="ml-2"
                      small
                      tile
                      dark
                      color="success"
                      @click="updatePostBasic"
                    >
                      <span>保存</span>
                    </v-btn>

                    <v-btn
                      class="ml-2"
                      small
                      tile
                      dark
                      color="warning"
                      @click="cancelEditPostBasic"
                    >
                      <span>キャンセル</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-form>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col class="text-center" lg="4">
            <LeftPostBasic
              :post-type="post.postType"
              :eyecatchable-src="eyecatchableSrc"
              :eyecatch-source-url="
                post.eyecatchSourceUrl ? post.eyecatchSourceUrl : '未設定'
              "
              :product="post.product ? post.product : {}"
            ></LeftPostBasic>
          </v-col>
          <v-col lg="8">
            <div class="mb-2">
              <h2 class="title">
                {{ post.title | titlePresence }}
              </h2>
            </div>
            <div>
              <p class="body-2">
                {{ post.introduction | introductionPresence }}
              </p>
            </div>
            <div>
              <p class="slug">
                {{
                  ('パーマリンク' +
                    ' ' +
                    site.originalDomainWithProtocol +
                    '/' +
                    (post.slug || post.id))
                    | slugPresence
                }}
              </p>
            </div>
            <v-row>
              <v-col class="d-flex justify-space-between flex-wrap" cols="12">
                <div class="pa-1" style="min-width: 110px">
                  <span class="caption"> インデックス </span>

                  <v-icon v-if="post.isIndex" small color="success">
                    mdi-check-circle
                  </v-icon>
                  <v-icon v-else small color="error"> mdi-close-circle </v-icon>
                </div>
                <div class="pa-1" style="min-width: 130px">
                  <span class="caption"> ページネーション </span>

                  <v-icon v-if="post.isPagination" small color="success">
                    mdi-check-circle
                  </v-icon>
                  <v-icon v-else small color="error"> mdi-close-circle </v-icon>
                </div>
                <div class="pa-1" style="min-width: 110px">
                  <span class="caption"> 道徳的な記事 </span>

                  <v-icon v-if="post.isMoral" small color="success">
                    mdi-check-circle
                  </v-icon>
                  <v-icon v-else small color="error"> mdi-close-circle </v-icon>
                </div>
                <div class="pa-1" style="min-width: 110px">
                  <span class="caption"> PR </span>

                  <v-icon v-if="post.isPr" small color="success">
                    mdi-check-circle
                  </v-icon>
                  <v-icon v-else small color="error"> mdi-close-circle </v-icon>
                </div>
                <div class="pa-1" style="min-width: 110px">
                  <span class="caption"> 広告（ウィジェット）の表示 </span>

                  <v-icon v-if="post.displayWidget" small color="success">
                    mdi-check-circle
                  </v-icon>
                  <v-icon v-else small color="error"> mdi-close-circle </v-icon>
                </div>
                <div class="pa-1" style="min-width: 110px">
                  <span class="caption"> 景品表示法文言 </span>

                  <v-icon v-if="post.isPremiumDisplay" small color="success">
                    mdi-check-circle
                  </v-icon>
                  <v-icon v-else small color="error"> mdi-close-circle </v-icon>
                </div>
                <div class="pa-1" style="min-width: 110px">
                  <span
                    class="caption"
                    v-text="selectTableOfContentsLabel()"
                  ></span>

                  <v-icon
                    v-if="isDisplayedTableOfContents()"
                    small
                    color="success"
                  >
                    mdi-check-circle
                  </v-icon>
                  <v-icon v-else small color="error"> mdi-close-circle </v-icon>
                </div>
              </v-col>
              <v-col v-if="mode != 'readonly'" class="text-right">
                <v-btn
                  outlined
                  tile
                  small
                  color="primary"
                  class="ma-2"
                  @click="editPostBasic"
                >
                  <v-icon left small> mdi-pencil </v-icon>
                  編集する
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ImageUploaderSelecter from '../parts/ImageUploaderSelecter'
import InputLabel from '@/components/commons/formParts/inputLabel'
import LeftPostBasicEdit from '../parts/LeftPostBasicEdit'
import LeftPostBasic from '../parts/LeftPostBasic'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  components: {
    ImageUploaderSelecter,
    InputLabel,
    LeftPostBasicEdit,
    LeftPostBasic
  },
  filters: {
    titlePresence: (val) => {
      return val || 'タイトル未設定'
    },
    introductionPresence: (val) => {
      return val || '導入文未設定'
    },
    slugPresence: (val) => {
      return val || 'パーマリンク未設定'
    }
  },
  mixins: [formValidationUtils],
  data: function () {
    return {
      editablePostBasic: {},
      imageUploaderSelecter: false,
      postBasicEdit: false,
      isTableOfContentsTypes: [
        { name: 'トップページのみ表示', value: 'on_top_page' },
        { name: '全ページ表示', value: 'on_all_pages' },
        { name: '非表示', value: 'not_displayed' }
      ],
      valid: true
    }
  },
  computed: {
    ...mapState({
      post: (state) => state.PostEditor.post,
      mode: (state) => state.PostEditor.mode,
      site: (state) => state.SiteStore.site
    }),
    eyecatchable () {
      if (this.postBasicEdit) {
        return this.editablePostBasic.eyecatchable
      } else {
        return this.post.eyecatchable
      }
    },
    eyecatchableSrc () {
      if (this.post.imageDirectUrl) {
        return this.post.imageDirectUrl
      } else if (this.eyecatchable) {
        return this.eyecatchable.file.middle.url
      } else {
        return 'http://placehold.jp/eeeeee/cccccc/200x130.png?text=No%20Image'
      }
    },
    editingEyecatchableSrc () {
      if (this.editablePostBasic.imageDirectUrl) {
        return this.editablePostBasic.imageDirectUrl
      } else if (this.eyecatchable) {
        return this.eyecatchable.file.middle.url
      } else {
        return 'http://placehold.jp/eeeeee/cccccc/240x160.png?text=No%20Image'
      }
    }
  },
  methods: {
    editPostBasic () {
      if (this.mode === 'readonly') {
        return false
      }
      this.postBasicEdit = true
      this.editablePostBasic = {
        eyecatchable: this.post.eyecatchable,
        eyecatchableId: this.post.eyecatchableId,
        eyecatchableType: this.post.eyecatchableType,
        eyecatchSourceUrl: this.post.eyecatchSourceUrl,
        title: this.post.title,
        metaTitle: this.post.metaTitle,
        introduction: this.post.introduction,
        isIndex: this.post.isIndex,
        isPagination: this.post.isPagination,
        isMoral: this.post.isMoral,
        isPr: this.post.isPr,
        isTableOfContents: this.post.isTableOfContents,
        imageDirectUrl: this.post.imageDirectUrl,
        slug: this.post.slug || this.post.id,
        postType: this.post.postType,
        product: this.post.product,
        displayWidget: this.post.displayWidget,
        isPremiumDisplay: this.post.isPremiumDisplay,
        showNoindexPost: this.post.showNoindexPost
      }
    },
    cancelEditPostBasic () {
      this.postBasicEdit = false
      this.editablePostBasic = {}
    },
    validateForm () {
      this.valid =
        this.$refs.leftPostBasicForm.validate() &&
        this.$refs.rightPostBasicForm.validate()
    },
    updatePostBasic () {
      this.validateForm()
      if (!this.valid) return false
      this.$store.commit('PostEditor/UPDATE_POST_BASIC', this.editablePostBasic)
      this.$store.commit('PostEditor/SET_POST_SAVED_TO_DB', false)
      this.postBasicEdit = false
      this.valid = true
    },
    // 共通化したい
    initializeImageDirectUrl () {
      this.editablePostBasic.imageDirectUrl = null
    },
    deleteEyecatch () {
      this.editablePostBasic.eyecatchableId = null
      this.editablePostBasic.eyecatchableType = null
      this.editablePostBasic.eyecatchable = null
      this.initializeImageDirectUrl()
    },
    updateImage (picture) {
      this.editablePostBasic.eyecatchableId = picture.id
      this.editablePostBasic.eyecatchableType = 'Picture'
      this.editablePostBasic.eyecatchable = picture
      this.imageUploaderSelecter = false
      this.initializeImageDirectUrl()
    },
    uploadDownloadImage (downloadImage) {
      this.editablePostBasic.eyecatchableId = downloadImage.id
      this.editablePostBasic.eyecatchableType = 'DownloadImage'
      this.editablePostBasic.eyecatchable = downloadImage
      this.imageUploaderSelecter = false
      this.initializeImageDirectUrl()
    },
    uploadPicture (picture) {
      this.editablePostBasic.eyecatchableId = picture.id
      this.editablePostBasic.eyecatchableType = 'Picture'
      this.editablePostBasic.eyecatchable = picture
      this.imageUploaderSelecter = false
      this.initializeImageDirectUrl()
    },
    selectProduct (product) {
      this.editablePostBasic.product = product
    },
    selectTableOfContentsLabel () {
      return (
        this.isTableOfContentsTypes.find(
          (type) => type.value === this.post.isTableOfContents
        ) || this.isTableOfContentsTypes[0]
      ).name
    },
    isDisplayedTableOfContents () {
      return this.post.isTableOfContents !== 'not_displayed'
    }
  }
}
</script>

<style scoped lang="sass">
.p-postBasicEditor
  &__eyecatch
    background-color: #efefef
    width: 240px
    height: 160px
    position: relative
    margin: 0 auto

.right-line:after
  content: ''
  position: absolute
  top: 5%
  left: 32%
  display: inline-block
  width: 1px
  height: 500px
  background-color: black
</style>
